import { z } from 'my-zod'
import { reservationDepositPolicyFragment } from './reservation-deposit-policy-fragment'

export const reservationDepositPolicySystemView = reservationDepositPolicyFragment.pick({
  reservationDepositAmount: true,
  reservationDepositUnit: true
})

export type reservationDepositPolicySystemView = z.infer<typeof reservationDepositPolicySystemView>
